import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';
import { SCROLL_DURATION, SCROLL_OFFSET } from 'site-modules/shared/constants/sub-navigation';

export function ReviewSection({ title, body, rating, id, children, titleClasses, afterBodyChildren, allowNoBody }) {
  if (!body && !allowNoBody) {
    return null;
  }
  const hasChildren =
    children &&
    (Array.isArray(children) ? get(children[0], 'props.body.length', 0) : get(children, 'props.body.length', 0)) > 0;

  return (
    <div id={id} className="editorial-review-section">
      {hasChildren && !!id && <ScrollElement id={`scrollTop-${id}`} />}
      {!!title && (
        <div className="d-flex align-items-center">
          <h2 className={`${titleClasses || 'size-16 text-gray-darker'} mb-0`}>{title}</h2>
          {rating && <span className={`ms-0_5 ${titleClasses}`}>{rating}</span>}
        </div>
      )}

      {!!body && (
        <ContentFragment classes={classnames('editorial-review-section-fragment size-16', { first: hasChildren })}>
          {body}
        </ContentFragment>
      )}
      {!hasChildren && afterBodyChildren}

      {hasChildren && (
        <ContentCollapse
          isEclipseFade={false}
          btnClasses="px-0_5 py-0 mt-0_25 size-16 text-primary-darker"
          btnContainerClasses="py-0"
          justify="justify-content-start"
          showBtnBelow
          btnTextClasses="fw-normal"
          classes="size-16"
          resetParams={{
            offset: SCROLL_OFFSET,
            duration: SCROLL_DURATION,
            to: `scrollTop-${id}`,
          }}
        >
          <div className="mt-1_5">{children}</div>
          {afterBodyChildren}
        </ContentCollapse>
      )}
    </div>
  );
}

ReviewSection.propTypes = {
  body: PropTypes.string,
  title: PropTypes.string,
  rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  children: PropTypes.node,
  titleClasses: PropTypes.string,
  afterBodyChildren: PropTypes.node,
  allowNoBody: PropTypes.bool,
};

ReviewSection.defaultProps = {
  body: undefined,
  title: undefined,
  rating: undefined,
  id: undefined,
  children: false,
  titleClasses: '',
  afterBodyChildren: null,
  allowNoBody: false,
};
